import React, { MouseEvent, useState } from 'react';

import { Menu, MenuItem, MenuOption, Pressed } from 'libs/ui';
import { PropsWithTestAttribute } from 'types/testAttribute';

import { IconStyled } from './styles';

interface Props<T extends string | number> {
  options: MenuOption<T>[];
  variant?: 'horizontal' | 'vertical';
  onClickOption: (option: MenuItem<T>) => void;
}

export const MoreMenu = <T extends string | number>({
  options,
  variant = 'vertical',
  datax,
  onClickOption,
}: Props<T> & PropsWithTestAttribute) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickOption = (option: MenuItem<T>) => {
    onClickOption(option);
    handleClose();
  };

  return (
    <>
      <Pressed datax={datax} onClick={handleClick}>
        <IconStyled variant={variant} />
      </Pressed>

      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        open={open}
        options={options}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClickOption={handleClickOption}
        onClose={handleClose}
      />
    </>
  );
};
